<template>
    <el-dialog class="privatchat" :title="diatorTitle" :close-on-click-modal="false" :visible.sync="dialogVisible" :append-to-body="true" :before-close="handleClose" width="800px">
        <div class="chat_main">
            <div v-if="noMessageStatus" class="chat_messagebox">当前没有聊天信息</div>
            <el-tabs v-model="chatActive" tab-position="left" @tab-remove="removeTab" @tab-click="chageMember">
                <el-tab-pane
                    v-for="item in chatList"
                    :key="item.name"
                    :name="item.name">
                    <span slot="label"><i :class="[isnew==item.name?'new':'',item.role,'messageTag']"></i> {{item.title}}</span>
                    <div class="privatchat_main">
                        <div class="currentChatMember">正在与 {{item.title}} 交谈中</div>
                        <div class="chat-message_list" v-bind:id="'messageBox_'+item.name">
                            <ul>
                                <li v-for="msg in msgs[item.name]" :key="msg.index" :class="{'meeting-chatroom-self': msg.id==comdata.userID}">
                                    <span>{{ msg.who }}  {{msg.time}}</span> <div class="infobackground"><div x-arrow="" class="popper__arrow"></div>{{msg.content}}</div>
                                </li>
                            </ul>
                        </div>
                        <div class="chat-message_speaking">
                            <textarea v-model="inputMessage" @keyup.enter="onSendMessageClick(item.name)" class="input-textarea" placeholder="在此输入消息，按回车键发送"></textarea>
                            <div class="chat-message_btnSend">
                                <!-- <i class="expression-icon"></i> -->
                                <button @click="onSendMessageClick(item.name)">发送</button>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </el-dialog>
</template>
<script>
    export default {
    model: {
        prop: 'comdata',
        event: 'change'
    },
    data() {
        return {
            dialogVisible: false, // 显示弹窗
            dialogType: '', // 显示哪个内容弹窗
            diatorTitle: '私聊窗口',
            chatActive: '2',
            chatList: [],
            tabIndex: 2,
            msgs: {},
            inputMessage: "",
            currentMemberId: '',
            mediatorInfo: {},
            isnew:null,
            appclas: 'appclas',
            dialogInit: true,
            noMessageStatus: false,
            memberstype: {
                "LITIGANT_WITNESS": "证人",
                "LITIGANT_THIRD": "第三人",
                "MEDIATOR": '仲裁员',
                "LITIGANT":'参会人',
                "APPLICANT_AGENT":'申请人代理人',
                'APPLICANT': '申请人',
                "RESPONDENT":'被申请人',
                "RESPONDENT_AGENT":'被申请人代理人',
                'OTHER': '其他人',
                "PETITION_AGENT":'信访代理人',
                'MEDIATOR_HELP_TEMPORARY':'协助调解员',
                'MEDIATOR_HELP':'协助调解员',
                'INVITATION_WATCHER': '观摩人',
                'INVITATION_WATCHER2': '仲裁员'
            },
            chatRecordStatus: {},
            messagePageIndex: 1,
            messageTotalPages: '',
            onceLoadMessage: true,
            messageListLoad: true,
            messageListBody:'',
            memberListCreatStatus:false
        }
    },
    props:['comdata','wselement','socketStatus','members'],
    watch: {
        comdata: {
            handler: function (newData, oldData) {
                let self = this
                self.$nextTick(function () {
                })
            }
        },
        members: {
            handler: function (newData, oldData) {
                let self = this
                self.$nextTick(function () {
                })
            }
        }
    },
    mounted() {
    },
    methods: {
        openDialog(userid,username,rolename,role) {
            if(this.memberListCreatStatus) {
                this.dialogVisible = true;
                this.scrollMessage();
                return;
            }
            let self = this, isrepeat = true;
            console.log(this.members)

            this.members.forEach((item,index,array) => {
                if(item.memberId != self.comdata.userID) {
                    for(let i = 0; i<self.chatList.length; i++) {
                        if(self.chatList[i].name == item.memberId) {
                            isrepeat = false;
                            break;
                        }else{
                            isrepeat = true;
                        }
                    }
                    console.log("哈哈——"+isrepeat)
                    if(isrepeat){
                        self.chatList.push({title:item.memberType=="MEDIATOR"?self.memberstype[item.memberType]:self.memberstype[item.memberType]+'-'+item.memberName, name:item.memberId, role:item.memberType});
                        // self.chatList.push({title:'工作人员-'+item.memberName, name:item.memberId, role:item.memberType});
                        self.$set(self.chatRecordStatus,item.memberId,{id:item.memberId, isall:false, curpage:1, addevent:true});
                        self.$set(self.msgs,item.memberId,[]);
                    }
                }
            })
            self.memberListCreatStatus = true;
            self.chatActive = self.chatList[0].name;
            self.currentMemberId = self.chatList[0].name;
            self.dialogVisible = true;
            if(!Boolean(self.chatRecordStatus[self.currentMemberId].isall)) self.listMessage(1,self.currentMemberId);
            self.scrollMessage();
        },
        listMessage(pageindex,sendid) { // 拉取消息记录
            let self = this, data;
            data = {
                senderId: sendid,
                pageIndex: pageindex,
                pageSize: 500
            };
            var msgdata = {};
            msgdata.event = "LIST_MESSAGE";
            msgdata.data = data;
            self.wselement.send(JSON.stringify(msgdata))
        },
        createChat(userid,username,rolename,role) {
            let self = this, isrepeat = true;
            if(this.noMessageStatus) this.noMessageStatus = false;
            if(!self.comdata.mediatorself) self.mediatorInfo = userid;
            for(let i = 0; i<self.chatList.length; i++) {
                if(self.chatList[i].name == userid) {
                    isrepeat = false;
                    break;
                }
            }
            if(isrepeat){
                self.chatList.push({title:role?rolename+'-'+username:rolename, name:userid, role:role});
                self.$set(self.chatRecordStatus,userid,{id:userid, isall:false, curpage:1, addevent:true})
                self.$set(self.msgs,userid,[])
            }
            self.chatActive = userid;
            self.currentMemberId = userid;
            if(!Boolean(self.chatRecordStatus[userid].isall)) self.listMessage(1,userid);
            self.dialogVisible = true;
            self.scrollMessage();
            if(self.isnew == userid) self.isnew = null;
        },
        addTab(targetName) {
            let newTabName = ++this.tabIndex + '';
            this.editableTabs2.push({
                title: 'New Tab',
                name: newTabName,
                content: 'New Tab content'
            });
            this.editableTabsValue2 = newTabName;
        },
        scrollMessage() {
            let self = this, isrepeat = true, t, context;
            context=document.getElementById('messageBox_'+self.currentMemberId)
            if (context) {t =setTimeout(function(){context.scrollTop=context.scrollHeight},200)}
        },
        chageMember(item) {
            this.$emit('comcallback',item.name);
            this.isnew = null
            this.currentMemberId = item.name;
            if(!Boolean(this.chatRecordStatus[this.currentMemberId].isall)) this.listMessage(1,item.name);
            this.scrollMessage()
        },
        removeTab(targetName) {
            let tabs = this.editableTabs2;
            let activeName = this.editableTabsValue2;
            if (activeName === targetName) {
                tabs.forEach((tab, index) => {
                    if (tab.name === targetName) {
                        let nextTab = tabs[index + 1] || tabs[index - 1];
                        if (nextTab) {
                            activeName = nextTab.name;
                        }
                    }
                });
            }
            this.editableTabsValue2 = activeName;
            this.editableTabs2 = tabs.filter(tab => tab.name !== targetName);
        },
        onSendMessageClick(id) {
            var self = this;
            var msg = this.inputMessage;
            self.inputMessage = "";
            var data = {
                content: msg,
                receiverId: self.currentMemberId
            };
            var msgdata = {};
            msgdata.event = "SEND_TEXT";
            msgdata.data = data;
            if(!self.socketStatus){
                self.wselement.onopen = function(evt) {
                    self.socketStatus = true
                }
            }
            self.wselement.send(JSON.stringify(msgdata))
        },
        loadMsgList(data) {
            if(!Boolean(data.list.length)){
                this.chatRecordStatus[this.currentMemberId].isall = true;
                return;
            }
            let self = this,  messagelist = [], context, t, messageListBody, curMemberRecordStatus = this.chatRecordStatus[this.currentMemberId];
            if(curMemberRecordStatus.isall) return;
            self.messageListBody = messageListBody = document.querySelector('#messageBox_'+self.currentMemberId);
            self.messageListLoad = true;
            self.messagePageIndex = curMemberRecordStatus.curpage = Number(curMemberRecordStatus.curpage) + 1;
            self.messageTotalPages = data.totalPages;
            data.list.forEach((item,index,array) => {
                messagelist.unshift({who:"【"+self.memberstype[item.sender.memberType]+"】"+(item.sender.memberType === 'MEDIATOR' ? '仲裁员': item.sender.memberName),id:item.sender.memberId,content:item.messageContent,time:this.timestoday(item.createTime)})
            });
            self.msgs[self.currentMemberId]=messagelist.concat(self.msgs[self.currentMemberId]);
            if(curMemberRecordStatus.addevent) {
                t = setTimeout(function(){messageListBody.scrollTop=messageListBody.scrollHeight},200)
                messageListBody.addEventListener('scroll', self.pullMessage, false);
            }
            curMemberRecordStatus.addevent = false;
            if(curMemberRecordStatus.curpage>data.totalPages){
                curMemberRecordStatus.isall = true
                messageListBody.removeEventListener('scroll', self.pullMessage, false);
            };
        },
        pullMessage() {
            let self = this;
            if(self.messageListBody.scrollTop == 0&&self.messagePageIndex<=self.messageTotalPages&&self.messageListLoad){
                self.messageListLoad = false;
                self.listMessage(self.chatRecordStatus[self.currentMemberId].curpage,self.currentMemberId);
            }
        },
        uploadMsgList(message) {
            let context, self = this, broadcast, t, isrepeat = true;
            const memberstype = {
                "LITIGANT_WITNESS": "证人",
                "LITIGANT_THIRD": "第三人",
                "MEDIATOR": '仲裁员',
                "LITIGANT":'参会人',
                "APPLICANT_AGENT":'申请人代理人',
                'APPLICANT': '申请人',
                "RESPONDENT":'被申请人',
                "RESPONDENT_AGENT":'被申请人代理人',
                'OTHER': '其他人',
                "PETITION_AGENT":'信访代理人',
                'MEDIATOR_HELP_TEMPORARY':'协助调解员',
                'MEDIATOR_HELP':'协助调解员',
                'INVITATION_WATCHER': '观摩人',
                'INVITATION_WATCHER2': '仲裁员'
            }
            if(self.noMessageStatus) self.noMessageStatus = false;
            for(let i = 0; i<self.chatList.length; i++) {
                if(self.chatList[i].name == message.sender.memberId) {
                    isrepeat = false;
                    break;
                }else if(self.comdata.userID == message.sender.memberId){
                    isrepeat = false;
                    break;
                }
            }
            if(isrepeat&&self.comdata.mediatorself){
                self.chatList.push({title:memberstype[message.sender.memberType]+'-'+message.sender.memberName,name:message.sender.memberId,role:message.sender.memberType});
                self.chatActive = message.sender.memberId;
                self.currentMemberId = message.sender.memberId;
                self.$set(self.chatRecordStatus,message.sender.memberId,{id:message.sender.memberId, isall:false, curpage:1, addevent:true});
                self.$set(self.msgs,message.sender.memberId,[]);
            }
            if(!Boolean(self.chatRecordStatus[self.currentMemberId])||!Boolean(self.chatRecordStatus[self.currentMemberId].isall)) return;
            broadcast = {who:"【"+memberstype[message.sender.memberType]+"】"+(message.sender.memberType === 'MEDIATOR' ? '仲裁员': message.sender.memberName),id:message.sender.memberId,content:message.messageContent,time:self.timestoday(message.createTime)}
            // if(self.comdata.mediatorself) {
                if(message.sender.memberId == self.comdata.userID) {
                    if(!Boolean(self.msgs[message.receiver.memberId])) self.$set(self.msgs,message.receiver.memberId,[]);
                    self.msgs[message.receiver.memberId].push(broadcast)
                    context=document.getElementById('messageBox_'+message.receiver.memberId);
                }else{
                    if(!Boolean(self.msgs[message.sender.memberId])) self.$set(self.msgs,message.sender.memberId,[]);
                    self.msgs[message.sender.memberId].push(broadcast)
                    context=document.getElementById('messageBox_'+message.sender.memberId)
                    if(self.currentMemberId != message.sender.memberId||!self.dialogVisible) self.isnew = message.sender.memberId
                }
            // }else {
            //     if(!Boolean(self.msgs[message.sender.memberId])) self.$set(self.msgs,message.sender.memberId,[]);
            //     self.msgs[message.sender.memberId].push(broadcast)
            //     context=document.getElementById('messageBox_'+message.sender.memberId)
            // }
            if (context) {t =setTimeout(function(){context.scrollTop=context.scrollHeight},200)}
        },
        timestoday(t) {
            var times = new Date(t);
            var ty = times.getFullYear(), tm = times.getMonth()+1, td = times.getDate(), th = times.getHours(), tmt = times.getMinutes(), ts = times.getSeconds();
            var ntostring = function(d){
                if(d.toString().length ==1){
                    return "0"+d;
                }
                return d;
            }
            return ntostring(th)+":"+ntostring(tmt);
        },
        handleClose(done) {
            this.$emit('comcallback');
            done();
        }
    }
}
</script>
<style lang="scss">
    .privatchat {
        .el-dialog__body {
            padding:0;
        }
        .el-tabs--left .el-tabs__header.is-left {
            margin-right:0;
        }
        .el-tabs__header {
            width: 260px;
        }
        .el-tabs--left .el-tabs__item.is-left {
            text-align: left;
        }
        .el-tabs__item.is-left.is-active {
            color: #4b4b4b;
            background-color: #e6e6e6;
        }
        .messageTag {
            display: inline-block;
            width: 8px;
            height: 8px;
            margin-bottom: 4px;
            margin-right: 10px;
            background-color: #0083c8;
            border-radius: 10px;
            vertical-align: middle;
        }
        .new.messageTag {
            background-color: #0083c8;
        }
        .APPLICANT {
            background-color: #0083c8;
        }
        .RESPONDENT {
            background-color: #bbbbbb;
        }
        .chat_messagebox {
            line-height: 200px;
            text-align: center;
            font-size: 18px;
        }
    }
    .privatchat_main {
        position: relative;
        height: 450px;
        .currentChatMember {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 25px;
            line-height: 25px;
            text-align: center;
            font-size: 14px;
            color: #0083c8;
            background-color: #fff;
        }
        .chat-message_list {
            position: absolute;
            top: 25px;
            bottom: 125px;
            left: 0;
            right: 0;
            margin: 0;
            padding: 20px;
            background-color: #f8f8f8;
            box-sizing: border-box;
            overflow-y: auto;
            li {
                padding: 10px 0 15px;
                span {
                    display: block;
                    padding-bottom: 6px;
                    color: #888888;
                    font-size: 14px;
                }
                div.infobackground {
                    position: relative;
                    display: inline-block;
                    padding: 10px 15px;
                    line-height: 22px;
                    color: #494949;
                    font-size: 14px;
                    background-color: #fff;
                    border: 1px solid #f0f0f0;
                    border-radius: 2px;
                    text-align: left;
                    .popper__arrow {
                        position: absolute;
                        display: block;
                        top: -6px;
                        left: 20px;
                        width: 0;
                        height: 0;
                        border-color: transparent;
                        border-style: solid;
                        border-width: 6px;
                        margin-right: 3px;
                        border-top-width: 0;
                        border-bottom-color: #f0f0f0;
                        &:after {
                            position: absolute;
                            display: block;
                            width: 0;
                            height: 0;
                            content: " ";
                            border-width: 6px;
                            border-color: transparent;
                            border-style: solid;
                            top: 1px;
                            margin-left: -6px;
                            border-top-width: 0;
                            border-bottom-color: #fff;
                        }
                    }
                }
            }
            li.meeting-chatroom-self {
                text-align: right;
                div.infobackground {
                    color: #ffffff;
                    background-color: #0083c8;
                    border: 1px solid #0083c8;
                    .popper__arrow {
                        left: inherit;
                        right: 20px;
                        border-bottom-color: #0083c8;
                        &:after {
                            border-bottom-color: #0083c8;
                        }
                    }
                }
            }
        }
        .chat-message_speaking {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 5px;
            height: 100px;
            padding: 10px;
            background-color: #f8f8f8;
            border-top: 1px solid #ececec;
            .input-textarea {
                font-size: 12px;
                width: 100%;
                height: 80px;
                display: inline-block;
                padding: 5px 10px;
                border: none;
                color: #494949;
                background-color: #f8f8f8;
                resize: none;
                outline: 0;
                -webkit-appearance: none;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                -webkit-transition: all .3s cubic-bezier(.645,.045,.355,1);
                -webkit-transition: all .3s cubic-bezier(0.65, 0.05, 0.36, 1);
                transition: all .3s cubic-bezier(0.65, 0.05, 0.36, 1);
            }
        }
        .chat-message_btnSend {
            display: inline-block;
            vertical-align: top;
            button {
                position: absolute;
                bottom: 20px;
                right: 30px;
                height: 28px;
                width: 60px;
                color: #fff;
                border: none;
                outline: 0;
                background-color: #0083c8;
                box-shadow: 0 5px 8px 0 rgba(0, 117, 206, 0.25);
                cursor: pointer;
            }
        }
    }
</style>

